import EmiratesIntroSection from "../Home/EmiratesIntroSection.jsx";

const AboutProgram = () => <EmiratesIntroSection />;

export default AboutProgram;
